import * as React from 'react'

import { ChevronRightIcon } from 'lucide-react'

interface IProps {
  label: string
  onClick?: () => void
  isLast?: boolean
}

export default function Breadcrumb({
  label: text,
  onClick,
  isLast,
}: IProps): JSX.Element {
  return (
    <>
      <span
        className="w-fit-content text size22 line-28 ellipsis pointer brada24 px12 py6 highlighted-hover highlighted-active"
        onClick={onClick}
      >
        {text}
      </span>
      {!isLast && (
        <ChevronRightIcon
          size={20}
          className="tw:mx-1 tw:shrink-0 tw:text-muted-foreground"
        />
      )}
    </>
  )
}
